import React from "react";
import { Combo } from "../../common/components/comboBox";
import { withMarcheCaldaie } from "../withModelliClima";
import { formGroup } from "../../common/components/formGroup";
import { TextInputHints } from "../../common/components/TextInputHints";

const Combobox = Combo<string>();
interface Props {
    data: string[],
    value: string | null,
    onChange: (type: string | null) => void
    error?: string;
    label?: string;
    onBlur?: React.FocusEventHandler;
    onFocus?: React.FocusEventHandler;
}
class __MarcaCaldaiaSelector extends React.PureComponent<Props> {

    render() {
        const { data, onChange, value, error, label, onBlur, onFocus } = this.props;
        return <Combobox
            label={label}
            allowNull
            data={data}
            textField={x => x}
            onSelect={onChange}
            value={value}
            error={error}
            onBlur={onBlur}
            onFocus={onFocus}
        />;
    }
}
export const MarcaCaldaiaSelector = formGroup(withMarcheCaldaie(__MarcaCaldaiaSelector)(x => x.getall(), "data"))

class __MarcaCaldaiaSelectorFree extends React.PureComponent<Props> {

    render() {
        const { data, onChange, value, error, label, onBlur, onFocus } = this.props;
        return <TextInputHints
            label={label}
            ActionsGet={async x => x}
            ActionsSearch={async filter => data.filter(x => x.toLowerCase().indexOf(filter.toLowerCase()) != -1)}
            onChange={onChange}
            value={value ?? ""}
            error={error}
            onBlur={onBlur}
            onFocus={onFocus}
        />;
    }
}
export const MarcaCaldaiaSelectorFree = formGroup(withMarcheCaldaie(__MarcaCaldaiaSelectorFree)(x => x.getall(), "data"))

